import classNames from 'classnames'
import { useEffect, useRef } from 'react'
import s from './index.module.css'

const Textarea = ({
  className,
  error,
  style,
  onChange = (e) => {},
  inputRef,
  collapsed = false,
  collapsedHeight = 44,
  maxAutoHeight,
  ...props
}) => {
  const refTextarea = useRef()

  const setTextareaRef = (node) => {
    refTextarea.current = node
    if (typeof inputRef === 'function') {
      inputRef(node)
    } else if (inputRef) {
      inputRef.current = node
    }
  }

  const syncHeight = () => {
    let textarea = refTextarea.current
    if (!textarea) return

    if (collapsed) {
      textarea.style.height = collapsedHeight + 'px'
      textarea.style.overflowY = 'hidden'
      return
    }

    textarea.style.height = 'auto'
    let height = textarea.scrollHeight
    const cssMinHeight = parseFloat(getComputedStyle(textarea).minHeight) || 0
    height = Math.max(height, cssMinHeight)

    const resolvedMaxHeight =
      Number.isFinite(Number(maxAutoHeight)) && Number(maxAutoHeight) > 0
        ? Number(maxAutoHeight)
        : null

    if (resolvedMaxHeight != null) {
      textarea.style.height = Math.min(height, resolvedMaxHeight) + 'px'
      textarea.style.overflowY = height > resolvedMaxHeight ? 'auto' : 'hidden'
      return
    }

    textarea.style.height = height + 'px'
    textarea.style.overflowY = 'hidden'
  }

  let func = (e) => {
    onChange(e)
    syncHeight()
  }

  const handleWheel = (e) => {
    const textarea = e.currentTarget
    if (textarea.scrollHeight > textarea.clientHeight + 1) {
      // не отдавать wheel родительскому скроллу модалки
      e.stopPropagation()
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    syncHeight()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value, collapsed, collapsedHeight, maxAutoHeight])

  return (
    <div style={style} className={s.wrapper}>
      <textarea
        ref={setTextareaRef}
        onChange={func}
        onWheel={handleWheel}
        data-collapsed={collapsed ? 'true' : undefined}
        className={classNames(
          s.textarea,
          { [className]: className },
          { [s.error]: error },
        )}
        style={
          collapsed
            ? {
                minHeight: `${collapsedHeight}px`,
                maxHeight: `${collapsedHeight}px`,
                overflowY: 'hidden',
              }
            : undefined
        }
        {...props}
      ></textarea>
    </div>
  )
}

export default Textarea
